export default class TechnologiesAnimation {
    static init() {
        window.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                const technologies = document.querySelectorAll('.technology');
                const options = {
                    root: null,
                    rootMargin: '0px 0px -250px 0px',
                    threshold: 0,
                };
                const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelector('.technology-content').classList.add('visible');
                    }
                }), options);

                technologies.forEach((technology) => observer.observe(technology));
            }, 500);
        });
    }
}
